var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.9375C12.2187 0.9375 9.49987 1.76225 7.1873 3.30746C4.87473 4.85267 3.07231 7.04893 2.00795 9.61851C0.943593 12.1881 0.665109 15.0156 1.20771 17.7435C1.75032 20.4713 3.08964 22.977 5.05632 24.9437C7.02299 26.9104 9.52869 28.2497 12.2565 28.7923C14.9844 29.3349 17.8119 29.0564 20.3815 27.9921C22.9511 26.9277 25.1473 25.1253 26.6925 22.8127C28.2378 20.5001 29.0625 17.7813 29.0625 15C29.0625 11.2704 27.5809 7.69354 24.9437 5.05631C22.3065 2.41908 18.7296 0.9375 15 0.9375ZM15 27.1875C12.5895 27.1875 10.2332 26.4727 8.22899 25.1335C6.22477 23.7944 4.66267 21.8909 3.74022 19.664C2.81778 17.437 2.57643 14.9865 3.04669 12.6223C3.51694 10.2582 4.67769 8.08659 6.38214 6.38214C8.0866 4.67768 10.2582 3.51694 12.6223 3.04668C14.9865 2.57642 17.437 2.81778 19.664 3.74022C21.8909 4.66266 23.7944 6.22476 25.1335 8.22899C26.4727 10.2332 27.1875 12.5895 27.1875 15C27.1875 18.2323 25.9035 21.3323 23.6179 23.6179C21.3323 25.9035 18.2323 27.1875 15 27.1875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 7.5H15.9375V18.75H14.0625V7.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 20.625H15.9375V22.5H14.0625V20.625Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.92a2fe21e3ddeadc08af05f378ac021c.svg";
export { ForwardRef as ReactComponent };